"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemFeesProductNames = exports.CBD_THC_UNIT = exports.USProductCSVHeaders = exports.CAProductCSVHeaders = exports.ProductsFileType = void 0;
__exportStar(require("./productImages"), exports);
var ProductsFileType;
(function (ProductsFileType) {
    ProductsFileType["XLS"] = "xls";
    ProductsFileType["XLSX"] = "xlsx";
    ProductsFileType["CSV"] = "csv";
})(ProductsFileType || (exports.ProductsFileType = ProductsFileType = {}));
var CAProductCSVHeaders;
(function (CAProductCSVHeaders) {
    CAProductCSVHeaders["ID"] = "ID";
    CAProductCSVHeaders["SKU"] = "SKU";
    CAProductCSVHeaders["PARENT_ID"] = "Parent ID";
    CAProductCSVHeaders["PARENT_SKU"] = "Parent SKU";
    CAProductCSVHeaders["FULL_NAME"] = "Full Name";
    CAProductCSVHeaders["NAME"] = "Name";
    CAProductCSVHeaders["PARENT_NAME"] = "Parent Name";
    CAProductCSVHeaders["IMAGE_URL"] = "Image URL";
    CAProductCSVHeaders["IS_ACTIVE"] = "Is Active";
    CAProductCSVHeaders["IS_MASTER_PRODUCT"] = "Is Master Product";
    CAProductCSVHeaders["IS_TRACKING_INVENTORY"] = "Is Tracking Inventory";
    CAProductCSVHeaders["PRICE"] = "Retail Price";
    CAProductCSVHeaders["CATEGORY"] = "Category";
    CAProductCSVHeaders["BRAND"] = "Brand";
    CAProductCSVHeaders["DEPOSIT_FEE"] = "Deposit Fee";
    CAProductCSVHeaders["TAX"] = "Tax";
    CAProductCSVHeaders["PURCHASE_PRICE"] = "Wholesale Cost";
    CAProductCSVHeaders["DESCRIPTION"] = "Description";
    CAProductCSVHeaders["BARCODE"] = "Barcode";
    CAProductCSVHeaders["SHORT_DESCRIPTION"] = "Receipt Description";
    CAProductCSVHeaders["WEIGHT"] = "Net Product Weight";
    CAProductCSVHeaders["CANNABIS_WEIGHT"] = "Cannabis Weight";
    CAProductCSVHeaders["COMPLIANCE_WEIGHT"] = "Compliance Weight";
    CAProductCSVHeaders["CANNABIS_VOLUME"] = "Cannabis Volume";
    CAProductCSVHeaders["VOLUME"] = "Volume";
    CAProductCSVHeaders["THC"] = "THC";
    CAProductCSVHeaders["CBD"] = "CBD";
    CAProductCSVHeaders["MAX_CBD"] = "Max CBD";
    CAProductCSVHeaders["MIN_CBD"] = "Min CBD";
    CAProductCSVHeaders["MAX_THC"] = "Max THC";
    CAProductCSVHeaders["MIN_THC"] = "Min THC";
    CAProductCSVHeaders["SHOW_MAX_MIN"] = "Show Min Max THC CBD";
    CAProductCSVHeaders["UNIT"] = "THC/CBD Unit";
    CAProductCSVHeaders["TRACK_LOTS"] = "Track Lots";
    CAProductCSVHeaders["TAGS"] = "Tags";
    CAProductCSVHeaders["STRAIN_TYPE"] = "Strain Type";
    CAProductCSVHeaders["CREATED"] = "Created";
    CAProductCSVHeaders["UPDATED"] = "Updated";
})(CAProductCSVHeaders || (exports.CAProductCSVHeaders = CAProductCSVHeaders = {}));
var USProductCSVHeaders;
(function (USProductCSVHeaders) {
    USProductCSVHeaders["ID"] = "ID";
    USProductCSVHeaders["SKU"] = "SKU";
    USProductCSVHeaders["NAME"] = "Name";
    USProductCSVHeaders["CATEGORY"] = "Category";
    USProductCSVHeaders["SUBCATEGORY"] = "Subcategory";
    USProductCSVHeaders["BRAND"] = "Brand";
    USProductCSVHeaders["VENDOR"] = "Vendor";
    USProductCSVHeaders["IMAGE_URL"] = "Image URL";
    USProductCSVHeaders["TAGS"] = "Tags";
    USProductCSVHeaders["PURCHASE_PRICE"] = "Wholesale Cost";
    USProductCSVHeaders["PRICE"] = "Retail Price";
    USProductCSVHeaders["PRICING_TEMPLATE"] = "Pricing Template";
    USProductCSVHeaders["DESCRIPTION"] = "Description";
    USProductCSVHeaders["AVAILABLE_ONLINE"] = "Available Online";
    USProductCSVHeaders["IS_ACTIVE"] = "Is Active";
    USProductCSVHeaders["CANNABIS_WEIGHT"] = "Cannabis Weight";
    USProductCSVHeaders["WEIGHT_UNIT"] = "Weight Unit";
    USProductCSVHeaders["FLOWER_TYPE"] = "Flower Type";
    USProductCSVHeaders["SELL_TYPE"] = "Sell Type";
    USProductCSVHeaders["NET_PRODUCT_WEIGHT_VALUE"] = "Net Product Weight Value";
    USProductCSVHeaders["NET_PRODUCT_WEIGHT_UNIT"] = "Net Product Weight Unit";
    USProductCSVHeaders["CANNABIS_WEIGHT_UNIT"] = "Cannabis Weight Unit";
    USProductCSVHeaders["CANNABIS_VOLUME_VALUE"] = "Cannabis Volume Value";
    USProductCSVHeaders["CANNABIS_VOLUME_UNIT"] = "Cannabis Volume Unit";
    USProductCSVHeaders["THC_POTENCY_MG"] = "THC Potency (mg)";
    USProductCSVHeaders["THCA_POTENCY_MG"] = "THCA Potency (mg)";
    USProductCSVHeaders["CBD_POTENCY_MG"] = "CBD Potency (mg)";
    USProductCSVHeaders["CBDA_POTENCY_MG"] = "CBDA Potency (mg)";
    USProductCSVHeaders["CBN_POTENCY_MG"] = "CBN Potency (mg)";
    USProductCSVHeaders["CBG_POTENCY_MG"] = "CBG Potency (mg)";
    USProductCSVHeaders["THC_CONCENTRATION_PERCENT"] = "THC Concentration (%)";
    USProductCSVHeaders["THCA_CONCENTRATION_PERCENT"] = "THCA Concentration (%)";
    USProductCSVHeaders["CBD_CONCENTRATION_PERCENT"] = "CBD Concentration (%)";
    USProductCSVHeaders["CBDA_CONCENTRATION_PERCENT"] = "CBDA Concentration (%)";
    USProductCSVHeaders["CBN_CONCENTRATION_PERCENT"] = "CBN Concentration (%)";
    USProductCSVHeaders["CBG_CONCENTRATION_PERCENT"] = "CBG Concentration (%)";
    USProductCSVHeaders["CREATED"] = "Created";
    USProductCSVHeaders["UPDATED"] = "Updated";
})(USProductCSVHeaders || (exports.USProductCSVHeaders = USProductCSVHeaders = {}));
var CBD_THC_UNIT;
(function (CBD_THC_UNIT) {
    CBD_THC_UNIT["PERCENT"] = "%";
    CBD_THC_UNIT["MG"] = "mg";
    CBD_THC_UNIT["ML"] = "ml";
    CBD_THC_UNIT["MG_G"] = "mg/g";
    CBD_THC_UNIT["MG_ML"] = "mg/mL";
})(CBD_THC_UNIT || (exports.CBD_THC_UNIT = CBD_THC_UNIT = {}));
var SystemFeesProductNames;
(function (SystemFeesProductNames) {
    SystemFeesProductNames["SHIPPING"] = "shipping";
    SystemFeesProductNames["TIP"] = "tip";
    SystemFeesProductNames["SURCHARGE"] = "surcharge";
})(SystemFeesProductNames || (exports.SystemFeesProductNames = SystemFeesProductNames = {}));
//# sourceMappingURL=productV2.js.map